import React from "react";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { AuthenticatedResponse } from "../store/Interfaces";
import LoadingModal from "./LoadingModal";
import { Alert } from "reactstrap";
import { GoogleReCaptcha, GoogleReCaptchaProvider } from "react-google-recaptcha-v3";


export default class WelcomeForm extends React.Component {
  public state: {
    isLoading: boolean,
    isError: boolean,
    isSuccess: boolean,
    captchaToken: string | undefined,
    refreshReCaptcha: boolean,
  }

  constructor(props: {}) {
    super(props);
    this.state = {
      isLoading: false,
      isError: false,
      isSuccess: false,
      captchaToken: undefined,
      refreshReCaptcha: false,
    };
  }

  handleValidSubmit = (event: any, values: {
    username: string;
    password: string;
    captchatoken: string;
  }) => {

    this.setState({
      isLoading: true,
    });

    if (this.state.captchaToken) {

      values.captchatoken = this.state.captchaToken;

      this.setState({
        isLoading: true,
        refreshReCaptcha: !this.state.refreshReCaptcha
      });
      fetch(
        process.env.REACT_APP_API_HOST +
        `/Authenticate/Welcome`,
        {
          method: "POST",
          // credentials: "include",
          body: JSON.stringify(values),
          headers: {
            pragma: "no-cache",
            "cache-control": "no-cache",
            "content-type": "application/json",
          },
        }
      )
        .then((response) => {
          if (!response.ok) {

            this.catchNok(response);

          } else {


            this.setState({
              isLoading: false,
              isError: false,
              isSuccess: true,
              refreshReCaptcha: !this.state.refreshReCaptcha,
            });


          }
        })

        .catch((error) => {
          this.catchError(error);

        });
    } else {
      setTimeout(() => {
        this.handleValidSubmit(event, values);
      }
        , 500)

    }


  };

  public catchError(error: any) {
    this.setState({
      bans: [],
      isLoading: false,
      isError: true,
      refreshReCaptcha: !this.state.refreshReCaptcha,
    });
    // console.log(error);

  }
  public catchNok(response: Response) {
    this.setState({
      bans: [],
      isLoading: false,
      isError: true,
      refreshReCaptcha: !this.state.refreshReCaptcha,
    });

  }

  handleInvalidSubmit = (event: any, errors: any) => {

    // console.log(errors);
  };

  public componentDidMount() {
    this.ensureDataFetched();
  }

  private ensureDataFetched() {

  }

  componentDidUpdate() {

  }
  render() {

    return (

      <>
        {this.state.isError === true && <Alert color="danger">There was an error with your submission. </Alert>}
        {this.state.isSuccess === true && <Alert color="success">Thank you! If we have the username on file you will receive an email with a link to select a password. </Alert>}

        {this.state.isSuccess === false &&
          <AvForm
            onValidSubmit={this.handleValidSubmit}
            onInvalidSubmit={this.handleInvalidSubmit}
          >
            <AvField
              name="username"
              label="Username"
              type="text"
              validate={{
                required: {
                  value: true,
                  errorMessage: "Please enter your username"
                },
              }}
            />
            <div className="d-flex flex-row flex-wrap justify-content-between">
              <div className="d-flex flex-col">
                {this.state && <button className="btn btn-inverse btn-primary btn-sm" id="submit"><strong>VERIFY</strong></button>}


              </div>
              <div className="d-flex flex-col">
                <GoogleReCaptcha
                  refreshReCaptcha={this.state.refreshReCaptcha}
                  onVerify={(token) => {
                    this.setState({ captchaToken: token })

                  }}
                />
              </div>
            </div>


            <LoadingModal isLoading={this.state.isLoading}></LoadingModal>
          </AvForm>
        }
      </>
    );
  }
}
